<template>
    <a :href="landingUrl" class="auth-landing-link">
        {{ $t("auth_landing.link") }}
    </a>
</template>

<script setup>
import { useLandingUrl } from "@/composables/useLandingUrl.js";

const { landingUrl } = useLandingUrl();
</script>

<style lang="scss" scoped>
@use "@/styles/variables" as *;

.auth-landing-link {
    margin: 0 0 16px;

    font-family: $gilroy;
    font-weight: 600;
    font-size: 14px;
    line-height: 135.7%;
    text-decoration: none;
    // !important: the global `a { color: ... !important }` rule overrides it otherwise
    color: $black-color !important;
    transition: color 0.3s;

    &:hover,
    &:focus-visible {
        color: $purple-color !important;
    }
}
</style>
